import React from 'react'
import { Popover } from 'antd'

function PopoverCard(props) {
  const content = props.contentItem ? props.contentItem.content : ''
  const popoverDOM = <div style={{ width: '200px' }}>{content}</div>
  if (content && content.length <= 30) {
    return content
  }
  return (
    <Popover content={popoverDOM}>
      <div className="layout-text-overflow">{content}</div>
    </Popover>
  )
}

export default PopoverCard
